import type {
  RehajePlugin,
  RehajePluginConstructor,
  TypedDefinitionConstructor
} from '../types'

/**
 * 创建 Schema 插件
 * @param type
 * @param definition
 * @returns
 */
export const createSchemaPlugin = <
  Definition extends TypedDefinitionConstructor
>(
  type: string,
  definition: Definition
): RehajePluginConstructor => {
  return class SchemaPlugin implements RehajePlugin {
    visitors = {
      definitions: {
        [type]: definition
      }
    }
  }
}
